import { render, staticRenderFns } from "./SectorNews.vue?vue&type=template&id=71092006&scoped=true&"
import script from "./SectorNews.vue?vue&type=script&lang=js&"
export * from "./SectorNews.vue?vue&type=script&lang=js&"
import style0 from "./SectorNews.vue?vue&type=style&index=0&id=71092006&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71092006",
  null
  
)

export default component.exports